import {
    getAllMapParameter
} from "@/assets/api/home-api";
import store from "../store"
async function getApi() {
    var res = await getAllMapParameter({});
    var data = res.data;
    let apiData = _.groupBy(data, function(item) {
        return item.Type;
    });
    var obj = {
        gisUrl: apiData["Map_API_JS_Url"][0].Value,
        cssUrl: apiData["Map_API_Css_Url"][0].Value,
    }
    return obj;
}

export default {
    gisUrl: store.state.gisApi.gisUrl,
    cssUrl: store.state.gisApi.cssUrl,
    gisUrl1: "https://server.gispai.com/MapServerAPI/arcgis_js_api/3.29/", // api
    cssUrl1: "https://server.gispai.com/MapServerAPI/arcgis_js_api/3.29/esri/css/esri.css", // css
    baseMapUrl: "https://server.gispai.com/GSPServer/tile.ashx?tiletype=3&amp;dir=world102100&path=''&r={row}&c={col}&z={level}",
    webSocketUrl: "ws://127.0.0.1:50008",
    dojoConfig: {
        async: true,
        packages: [{
            name: "customLayer",
            location:location.pathname.replace(/\/[^/]*$/, '')  + '/utils/js/customLayer'
                // location: "http://192.168.31.187:8003/customLayer"
        }],
        has: {
            'esri-promise-compatibility': 1, // Use native Promises by default
            'esri-featurelayer-webgl': 1, // Enable FeatureLayer WebGL capabilities
        }
    }
};
